import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components';

class Wrapper extends Component {
  render() {
    const { componentTitle, clearStatusBarEntries, onClosePress } = this.props;

    return (
      <VFScreen
        onClose={onClosePress}
        title={componentTitle}
        clearStatusBarEntries={clearStatusBarEntries}
      />
    );
  }
}

Wrapper.propTypes = {
  componentTitle: PropTypes.string,
  clearStatusBarEntries: PropTypes.bool,
  onClosePress: PropTypes.func,
};

export { Wrapper as WrapperComponent };
export default Wrapper;
